import Vue from 'vue'
import Vuex from 'vuex'

import { ContactsModule, SnackModule, TechpackModule, UserModule } from 'vue-common'

import * as SharedFoldersModule from './sharedFolder'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    sharedFolders: { ...SharedFoldersModule, namespaced: true },
    techpack: { ...TechpackModule },
    user: { ...UserModule },
    contacts: { ...ContactsModule },
    snack: { ...SnackModule }
  }
})
